<button #fnbutton [id]="id" cdkTrapFocus attr.tabindex="-1" [ngClass]="{'disabled ': disabled, 'outline': outline}" [class]="'fn-button btn  btn-'+ type+'  btn-'+shape+' '+btnClass" [disabled]="( disabled || isLoading ) ? true : null" attr.fnId="{{id}}" [type]="btnType"  title="{{ text | fnTranslate }}">
  <ng-container *ngTemplateOutlet="template ? template : templateContent"></ng-container>
</button>
<ng-template #templateContent>
  @if (iconAddonBefore) {
    <fn-icon [id]="'iconAddonBefore_'+id" attr.fnId="{{id}}" [icon]="iconAddonBefore" [class]="'iconAddonBefore'">
    </fn-icon>
  }
  <div class="button-content" class=" {{contentClass}} " [style.lineHeight]="height" [id]="'button-content_'+id" attr.fnId="{{id}}">
    @if (!isLoading) {
      <span class="label" attr.fnId="{{id}}">{{ text | fnTranslate }}</span>
    }
    @if (isLoading) {
      <span class="label" attr.fnId="{{id}}" [title]="textLoading">{{ textLoading }}</span>
    }
  </div>
  @if (iconAddonAfter) {
    <fn-icon [icon]="iconAddonAfter" attr.fnId="{{id}}" [id]="'iconAddonAfter_'+id" [class]="'iconAddonAfter'" [ngStyle]="{'line-height': 'calc(' + height + ' - 1px)'}">
    </fn-icon>
  }
</ng-template>
